// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-0393fb4a]{text-transform:uppercase;font-size:.7rem}h4[data-v-0393fb4a]{font-family:trim-medium;font-size:2.5rem!important}", ""]);
// Exports
module.exports = exports;
